const mcuFields = {
  General: [
    { label: "Name", value: "title" },
    { label: "Manufacturer", value: "manufacturer" },
    // { label: "Open Source", value: "openSource" },
  ],
  Processor: [
    { label: "Microcontroller IC", value: "ic" },
    { label: "Frequency", value: "frequency" },
  ],
  Memory: [
    { label: "Flash", value: "flashMemory" },
    { label: "EEPROM", value: "eeprom" },
    { label: "RAM", value: "ram" },
  ],
  // "Digital I/O":[
  //   { label: "Total Pins", value: "ioDigital" },
  //   { label: "Voltage Output", value: "vOutput" },
  //   { label: "Voltage Input", value: "vInput" },
  // ] ,
  Peripherals: [
    { label: "Digital I/O", value: "ioDigital" },
    { label: "PWM", value: "pwm" },
    { label: "ADC", value: "adc" },
    { label: "DAC", value: "dac" },
  ],
  Communication: [
    { label: "UART", value: "uart" },
    { label: "SPI", value: "spi" },
    { label: "I2C", value: "i2c" },
    { label: "I2S", value: "i2s" },
    { label: "CAN", value: "can" },
  ],
  Wireless: [
    { label: "WiFi", value: "wifi" },
    { label: "Bluetooth", value: "bluetooth" },
  ],
  Ports: [
    { label: "USB", value: "usb" },
    // { label: "USB 3.0", value: "usb_3" },
    { label: "Ethernet", value: "ethernet" },
  ],
  Power: [
    { label: "DC Current", value: "dcCurrent" },
    { label: "Operating Voltage", value: "opVoltage" },
    { label: "Input Voltage", value: "inVoltage" },
  ],
  Sensors: [
    { label: "Accelerometer", value: "accelerometer" },
    { label: "Gyroscope", value: "gyroscope" },
    { label: "Hall Effect", value: "hallEffect" },
    { label: "Touch", value: "touch" },
  ],
  Design: [
    { label: "Dimensions", value: "dimensions" },
    { label: "Weight", value: "weight" },
  ],
  Other: [
    { label: "Cellular", value: "cellular" },
    { label: "GPS", value: "gps" },
    { label: "Additional Notes", value: "notes" },
  ],
};

const sbcFields = {
  General: [
    { label: "Name", value: "title" },
    { label: "Manufacturer", value: "manufacturer" },
    // { label: "Open Source", value: "openSource" },
  ],
  Core: [
    { label: "Processor", value: "processor" },
    { label: "Frequency", value: "frequency" },
    { label: "GPU", value: "gpu" },
  ],
  Memory: [{ label: "RAM", value: "ram" }],
  Storage: [
    { label: "SD Card Slot", value: "sd" },
    { label: "Onboard Flash", value: "onboardFlash" },
  ],
  Peripherals: [
    { label: "GPIO", value: "ioDigital" },
    { label: "PWM", value: "pwm" },
    { label: "ADC", value: "adc" },
    { label: "DAC", value: "dac" },
    { label: "UART", value: "uart" },
    { label: "SPI", value: "spi" },
    { label: "I2C", value: "i2c" },
    { label: "I2S", value: "i2s" },
    { label: "CAN", value: "can" },
  ],
  Wireless: [
    { label: "WiFi", value: "wifi" },
    { label: "Bluetooth", value: "bluetooth" },
  ],
  Ports: [
    { label: "Video", value: "video" },
    { label: "Audio", value: "audio" },
    { label: "USB 2.0", value: "usb_2" },
    { label: "USB 3.0", value: "usb_3" },
    { label: "Camera", value: "camera" },
    { label: "Serial ATA", value: "sata" },
    { label: "Ethernet", value: "ethernet" },
  ],
  Software: [{ label: "Operating Systems", value: "os" }],
  Power: [
    { label: "Source", value: "powerSource" },
    { label: "Input Voltage", value: "inVoltage" },
    // { label: "GPIO Max Output Current", value: "maxOutCurrent" },
  ],
  Design: [
    { label: "Dimensions", value: "dimensions" },
    { label: "Weight", value: "weight" },
  ],
  // Other: [{ label: "Additional Notes", value: "notes" }],
};

const mainMcuFields = [
  { label: "Microcontroller IC", value: "ic" },
  { label: "Frequency", value: "frequency" },
  { label: "Flash", value: "flashMemory" },
  { label: "EEPROM", value: "eeprom" },
  { label: "Digital I/O", value: "ioDigital" },
];

const mainSbcFields = [
  { label: "Processor", value: "processor" },
  { label: "Frequency", value: "frequency" },
  { label: "GPU", value: "gpu" },
  { label: "RAM", value: "ram" },
];

module.exports = { mcuFields, sbcFields, mainMcuFields, mainSbcFields };
